import { devLogger } from "utils/debug";

export const getCreatePriceTracking = ({ prices, ...props }) => {
  const result = {
    ...props,
    price_count: prices.length,
    ...prices.reduce(
      (memo, { unit_amount, currency, recurring }) => {
        if (memo.currencies.indexOf(currency) === -1) {
          memo.currencies.push(currency);
        }
        if (recurring && memo.intervals.indexOf(recurring.interval) === -1) {
          memo.intervals.push(recurring.interval);
        }
        if (Number.isInteger(unit_amount)) {
          memo.unit_amounts.push(unit_amount);
        }

        return memo;
      },
      {
        currencies: [],
        intervals: [],
        unit_amounts: []
      }
    )
  };
  devLogger("getCreatePriceTracking", result);
  return result;
};
